<template>
  <div class="portfolio-gallery">
    <div
      v-if="loading && !images.length"
      class="gallery-grid"
      aria-busy="true"
      aria-label="Bilder werden geladen"
    >
      <div v-for="n in 4" :key="n" class="gallery-skeleton" />
    </div>
    <div v-else-if="!images.length" class="gallery-empty" role="status">
      <p>
        {{
          error ? 'Die Bilder konnten gerade nicht geladen werden.' : 'Neue Arbeiten folgen bald.'
        }}
      </p>
      <button v-if="error" class="button button-outline" @click="$emit('retry')">
        Erneut laden <InkIcon name="arrow" />
      </button>
    </div>
    <template v-else>
      <div class="gallery-grid">
        <button
          v-for="(image, index) in images.slice(0, count)"
          :key="image.src"
          class="work-card"
          :aria-label="
            (kind === 'art' ? 'Kunstwerk' : 'Tattoo') + ' ' + (index + 1) + ' vergrössern'
          "
          @click="lightbox.open(index)"
        >
          <span class="work-photo"
            ><img
              :src="image.src"
              :alt="image.title"
              width="480"
              height="640"
              loading="lazy"
              decoding="async" /><span class="work-expand"><InkIcon name="diagonal" /></span
          ></span>
          <span class="work-caption"
            ><span>{{ kind === 'art' ? 'Soul Art' : 'Fineline & Blackwork' }}</span
            ><span>{{ String(index + 1).padStart(2, '0') }}</span></span
          >
        </button>
      </div>
      <div v-if="images.length > initial" class="gallery-actions">
        <p class="gallery-count" role="status">
          {{ Math.min(count, images.length) }} von {{ images.length }} Arbeiten
        </p>
        <button v-if="count < images.length" class="button button-outline" @click="count += 8">
          Mehr entdecken <InkIcon name="plus" />
        </button>
      </div>
    </template>
    <ImageLightbox ref="lightbox" :images="images" :kind="kind" />
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import InkIcon from './InkIcon.vue';
import ImageLightbox from './ImageLightbox.vue';
const props = defineProps({
  images: { type: Array, default: () => [] },
  kind: { type: String, default: 'tattoo' },
  loading: Boolean,
  error: Boolean,
  initial: { type: Number, default: 8 },
});
defineEmits(['retry']);
const count = ref(props.initial);
const lightbox = ref(null);
watch(
  () => props.kind,
  () => {
    count.value = props.initial;
  }
);
</script>
